import { render, staticRenderFns } from "./SpecialtyList.vue?vue&type=template&id=44d05b76&"
import script from "./SpecialtyList.vue?vue&type=script&lang=js&"
export * from "./SpecialtyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports